<template>
  <div class="container__content">
    <div class="wrapper">
      <div class="content-9">
        <div class="content-9__title">
          <span class="content-9__title__text">自定义彩种风格</span>
        </div>
        <div class="content-9__control">
          <div class="content-9__control__item">
            <div class="c8-select">
              <div class="c8-select__title">
                <span class="c8-select__title__text">选择展示类型：</span>
              </div>
              <div class="c8-select__content">
                <div
                  v-for="(item, index) in typeList"
                  :key="index"
                  class="checkbox c8-select__content__item"
                  :class="{active: item.active}"
                  @click="changeType(item)"
                >
                  <i class="checkbox__select"></i>
                  <label class="checkbox__label">{{ item.name }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="content-9__control__item">
            <div class="c8-select">
              <div class="c8-select__title">
                <span class="c8-select__title__text">选择展示彩种：</span>
              </div>
              <div class="c8-select__content-2">
                <div class="c8-select__content-2__menuber">
                  <div class="menubar">
                    <div class="menubar__itembox">
                      <div
                        v-for="(item, index) in groupList"
                        :key="index"
                        :class="{active: item.active}"
                        class="menubar__item"
                        @click="changeGroup(item)"
                      >
                        <span class="menubar__item__text">{{ item.name }}</span>
                        <div class="menubar__item__lightborder"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="activeGroup === 'gaopin'" class="c8-select__content-2__control">
                  <div class="libox">
                    <div class="libox__control">
                      <div class="libox__control__item">
                        <span class="libox__control__item__text">地区:</span>
                        <div class="selectbox">
                          <select v-model="gaopinCpPlace" class="selectbox__select" @change="changeGaopinCpyList('gaopin')">
                            <option value="">全部</option>
                            <option v-for="(place, key) in cpPlace" :key="place" :value="key">{{ place }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="libox__control__item">
                        <span class="libox__control__item__text">类型:</span>
                        <div class="selectbox">
                          <select v-model="gaopinCpType" class="selectbox__select" @change="changeGaopinCpyList('gaopin')">
                            <option value="">全部</option>
                            <option v-for="(type, key) in cpType" :key="type" :value="key">{{ type }}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="activeGroup === 'jisu'" class="c8-select__content-2__control">
                  <div class="libox">
                    <div class="libox__control">
                      <div class="libox__control__item">
                        <span class="libox__control__item__text">频率:</span>
                        <div class="selectbox">
                          <select v-model="jisuIntervalSecond" class="selectbox__select" @change="changeJisuCpyList('jisu')">
                            <option value="">全部</option>
                            <option v-for="(item, key) in intervalSeconds" :key="item" :value="item">{{ key }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="libox__control__item">
                        <span class="libox__control__item__text">类型:</span>
                        <div class="selectbox">
                          <select v-model="jisuCpType" class="selectbox__select" @change="changeJisuCpyList('jisu')">
                            <option value="">全部</option>
                            <option v-for="(type, key) in cpType" :key="type" :value="key">{{ type }}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="c8-select__content-2__btnbox">
                  <a
                    v-for="item in cpyList"
                    :key="item.code"
                    class="button-outline"
                    :class="{'active': activeKind(item)}"
                    @click="selectActiveCode(item)"
                  >
                    <span class="button-outline__text">{{ item.name }}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="content-9__control__item">
            <div class="c8-select">
              <div class="c8-select__title">
                <span class="c8-select__title__text">选择默认的彩种：</span>
              </div>
              <div class="c8-select__content">
                <div class="selectbox">
                  <select v-model="form.defaultCode" class="selectbox__select">
                    <option v-if="form.type === 'single' && form.selectCode !== '' " :value="form.defaultCode">{{ form.selectName }}</option>
                    <option v-for="item in form.selectCode" v-else :key="item.name" :value="item.code">{{ item.name }}</option>
                    <option v-if="form.selectCode.length === 0" :value="form.defaultCode">--请选择--</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="content-9__control__item">
            <div class="c8-select">
              <div class="c8-select__title">
                <span class="c8-select__title__text">选择尺寸：</span>
              </div>
              <div class="c8-select__content">
                <div class="btnbox">
                  <a
                    v-for="(size, index) in displaySize"
                    :key="index"
                    :class="{'active': size === form.size}"
                    class="button-outline btnbox__item"
                    @click="form.size = size"
                  >
                    <span class="button-outline__text">{{ size }}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="content-9__control__item">
            <div class="c8-select">
              <div class="c8-select__title">
                <span class="c8-select__title__text">背景色：</span>
              </div>
              <div class="c8-select__content">
                <input v-model="form.colorPick" class="input-color" type="color">
              </div>
            </div>
          </div>
        </div>
      </div>
      <PreviewEffect :data="form" :is-rwd="isRwd" />
    </div>
  </div>
</template>

<script>
import { getCpsList_desktop } from '@/api/desktop/basic'
import { getCpPlaceCode } from '@/api/public/basic'
import { lotteryTypeNameMapping } from '@/utils/steven/lotteryDictionary'
import PreviewEffect from '@/components/web/pages/transfer/PreviewEffect'
export default {
  name: 'WebTransfer',
  components: {
    PreviewEffect
  },
  data() {
    return {
      typeList: [
        { name: '多个彩种（下拉列表切换）', active: true, value: 'multiple' },
        { name: '单个彩种（仅显示一个彩种）', active: false, value: 'single' }
      ],
      groupList: [
        { name: '全国彩', active: true, val: 'china' },
        { name: '地方彩', active: false, val: 'local' },
        { name: '高频彩', active: false, val: 'gaopin' },
        { name: '极速彩', active: false, val: 'jisu' }
      ],
      form: {
        type: 'multiple',
        selectCode: [],
        selectName: '',
        defaultCode: '',
        size: '自适应',
        colorPick: '#ffffff'
      },
      cpyList: [],
      chinaCpyList: [],
      displaySize: ['自适应', '980x35', '850x35', '800x35', '900x50', '800x50'],
      activeGroup: 'china',
      cpType: {},
      cpPlace: {},
      intervalSeconds: {
        '一分钟': 60,
        '三分钟': 180,
        '五分钟': 300
      },
      gaopinCpPlace: '',
      gaopinCpType: '',
      jisuIntervalSecond: '',
      jisuCpType: ''
    }
  },
  computed: {
    isRwd() {
      return this.form.size === '自适应'
    }
  },
  async created() {
    await this.getCpsList('china')
    this.form.defaultCode = this.cpyList[0].code
    this.form.selectName = this.cpyList[0].name
  },
  methods: {
    async getCpsList(item) {
      const [data, error] = await getCpsList_desktop(item)
      if (error) return

      data.forEach(item => {
        item.active = false
      })

      this.cpyList = data
      this.chinaCpyList = data
    },
    changeType(item) {
      this.form.defaultCode = this.chinaCpyList[0].code
      this.form.selectName = this.chinaCpyList[0].name
      this.typeList.forEach(type => {
        type.active = false
      })
      item.active = !item.active
      this.form.type = item.value
      if (this.form.type === 'single') {
        this.form.selectCode = ''
      }
      if (this.form.type === 'multiple') {
        this.form.selectCode = []
      }
    },
    async changeGroup(item) {
      this.groupList.forEach(group => {
        group.active = false
      })
      item.active = !item.active
      this.activeGroup = item.val
      await this.getCpsList(item.val)
      this.cpType = {}
      if (item.val === 'gaopin') {
        this.getGaopinCpPlace()
        this.getCpType()
      }
      if (item.val === 'jisu') {
        this.getCpType()
      }
    },
    selectActiveCode(item) {
      if (this.form.type === 'single') {
        this.form.defaultCode = item.code
        this.form.selectCode = item.code
        this.form.selectName = item.name
      }
      if (this.form.type === 'multiple') {
        const obj = {}
        obj.name = item.name
        obj.code = item.code
        const selectCpCodeList = this.form.selectCode.map(item => item.code)
        if (selectCpCodeList.includes(item.code)) {
          const codeIndex = selectCpCodeList.indexOf(item.code)
          this.form.selectCode.splice(codeIndex, 1)

          const selectCodeLength = this.form.selectCode.length
          if (selectCodeLength > 0) {
            this.form.selectName = this.form.selectCode[selectCodeLength - 1].name
            this.form.defaultCode = this.form.selectCode[selectCodeLength - 1].code
          } else {
            this.form.selectName = this.cpyList[0].name
            this.form.defaultCode = this.cpyList[0].code
          }
        } else {
          this.form.selectCode.push(obj)
          this.form.selectName = obj.name
          this.form.defaultCode = obj.code
        }
      }
    },
    activeKind(item) {
      if (this.form.type === 'single') {
        return item.code === this.form.selectCode
      }
      if (this.form.type === 'multiple') {
        return this.form.selectCode.map(obj => obj.code).includes(item.code)
      }
    },
    async getGaopinCpPlace() {
      const [cpPlace, error] = await getCpPlaceCode()
      if (error) return
      this.cpPlace = cpPlace
    },
    getCpType() {
      this.cpyList
        .map(item => item.cpType)
        .filter((ele, index, arr) => arr.indexOf(ele) === index)
        .forEach(lotteryType => {
          this.cpType[lotteryType] = lotteryTypeNameMapping[lotteryType]
        })
    },
    async changeGaopinCpyList(item) {
      await this.getCpsList(item)
      this.cpyList = this.cpyList.filter(item => {
        const type = item.cpType === this.gaopinCpType
        const typeEmpty = this.gaopinCpType === ''

        const placeCode = item.placeCode === this.gaopinCpPlace
        const placeCodeEmpty = this.gaopinCpPlace === ''

        return (type || typeEmpty) && (placeCode || placeCodeEmpty)
      })
    },
    async changeJisuCpyList(item) {
      await this.getCpsList(item)
      this.cpyList = this.cpyList.filter(item => {
        const type = item.cpType === this.jisuCpType
        const typeEmpty = this.jisuCpType === ''

        const intervalSeconds = item.intervalSeconds === this.jisuIntervalSecond
        const intervalSecondsEmpty = this.jisuIntervalSecond === ''

        return (type || typeEmpty) && (intervalSeconds || intervalSecondsEmpty)
      })
    }
  }
}
</script>
